import { useHotelreservecardCancellationModal } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.hook";
import { HotelReserveCardCancellationModalType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal/hotel-reserve-card-cancellation-modal.types";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Skeleton } from "@website/ui/skeleton";
import { dateFormat } from "@website/utils/date-format";
import { deepCompare } from "@website/utils/deep-compare";
import { numberSeparator } from "@website/utils/number-separator";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelReserveCardCancellationModalType> = (properties) => {
  const router = useRouter();
  const { title, buttonProps, modalProps, policies, isLoading } =
    useHotelreservecardCancellationModal(properties);

  const {
    cancellationPolicies,
    bundleId,
    isBundleSelected,
    title: modalTitle
  } = properties;

  return (
    <Modal {...modalProps}>
      <div className="max-h-96 overflow-auto lg:w-[400px]">
        <div className="flex">
          <h3 className="text-headline-6">{modalTitle ?? title}</h3>
        </div>
        <div className="my-6 w-full rounded-lg border">
          {cancellationPolicies?.length && !isBundleSelected && (
            <table>
              <thead className="bg-dim-background">
                <tr>
                  <th
                    className="text-body-2 border px-4 py-3 text-left rtl:text-right"
                    scope="col"
                  >
                    شرایط زمانی کنسلی
                  </th>
                  <th className="text-body-2 border px-4 py-3" scope="col">
                    هزینه کنسلی
                  </th>
                </tr>
              </thead>
              <tbody>
                {cancellationPolicies &&
                  cancellationPolicies?.length &&
                  cancellationPolicies.map((item) => (
                    <tr key={`${item.from}_${item.amount}`}>
                      <td className="text-caption border p-4 text-left rtl:text-right">
                        {item?.from &&
                          dateFormat(item.from, {
                            locale: router.locale,
                            template: "DDD"
                          })}
                      </td>
                      <td className="text-caption border p-4 text-center rtl:text-right">
                        {item?.amount
                          ? `${numberSeparator(
                              Math.trunc(item.amount / 10)
                            )} تومان`
                          : ""}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}

          {isLoading && bundleId && <Skeleton height={250} />}
          {policies && (
            <ul className="px-2">
              {policies?.map((p) => (
                <li
                  className={`mb-6 ${
                    /[\u0600-\u06FF]/.test(p) ? "" : "text-left"
                  }`}
                  dangerouslySetInnerHTML={{
                    __html: p
                  }}
                  key={p}
                />
              ))}
            </ul>
          )}
        </div>
      </div>
      <Button {...buttonProps} />
    </Modal>
  );
};

export const HotelReserveCardCancellationModal = memo(Component, deepCompare);
